module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("i5vpo"))).then(() => parcelRequire('dJXJK'));